<template>
  <v-container class="main-container responsive-height create-investor-account-details">
    <v-row dense>
      <v-col cols="12" sm="4" md="4" lg="3">
        <v-row dense class="mb-2">
          <v-col cols="12">
            <v-card flat class="profile-card rounded-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
              <div class="user-profile">
                <div class="profile-image">
                  <v-badge avatar bordered overlap color="black accent-4">
                    <span class="numbers">{{ mammanagerstatistics.manager_rank }}</span>
                    <v-avatar size="47">
                       <v-img
                      :src="mammanagerstatistics?.profile_pic || `https://ui-avatars.com/api/?name=${mammanagerstatistics?.name}&background=random` || require('@/assets/avatar.png')"></v-img>
                    </v-avatar>
                  </v-badge>
                </div>
                <v-btn small class="mt-3" elevation="0" plain>
                  {{ mammanagerstatistics.name }}
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-card tile flat class="TitleCard mb-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-sheet class="mb-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                  <h2 class="mt-0">Account Number</h2>
                  <p class="mb-0">{{ mammanagerstatistics.trading_account_no }}</p>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" sm="8" md="8" lg="5">
        <v-card tile flat class="balanceCard" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-sheet class="d-flex mb-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                  <div class="title">
                    <span>Total Trades</span>
                    <p class="number mb-0">{{ mammanagerstatistics.total_trades }}</p>
                  </div>
                </v-sheet>
              </v-col>
              <v-col cols="12">
                <v-card-text class="d-flex pl-0 pb-2 mt-4 pr-0 trade align-center">
                  <p class="equity">
                    <span class="mb-2 d-inline-block">All Time Profit: </span>
                    {{ mammanagerstatistics.all_time_profit }}
                    <br />
                    <span class="mb-2 d-inline-block">Age (Days): </span>
                    {{ mammanagerstatistics.age }} <br />
                    <span class="mb-2 d-inline-block">Profit This Month: </span>
                    {{ mammanagerstatistics.profit_this_month }}
                  </p>
                  <v-spacer></v-spacer>
                  <p class="equity text-right">
                    <span class="mb-2 d-inline-block">Investors: </span> {{ mammanagerstatistics.investors }}
                    <br />
                    <span class="mb-2 d-inline-block">Profit Share: </span>
                    {{ mammanagerstatistics.profit_share }} <br />
                    <span class="mb-2 d-inline-block">Avg. Trade Duration: </span>
                    {{ mammanagerstatistics.average_trade_duration }}
                  </p>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="4">
        <v-card tile flat class="balanceCard" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-sheet class="d-flex mb-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                  <div class="title">
                    <span class="ml-0">Profitable Trades</span>
                    <p class="number mb-0">{{ mammanagerstatistics.profitable_trades }}</p>
                  </div>
                </v-sheet>
              </v-col>
              <v-col cols="12">
                <v-card-text class="d-flex pl-0 pb-2 mt-4 pr-0 trade align-center">
                  <p class="equity">
                    <span class="mb-2 d-inline-block">Buy: </span>
                    {{ mammanagerstatistics.buy }}
                    <br />
                    <span class="mb-2 d-inline-block">Max. Profit: </span> {{ mammanagerstatistics.max_profit }}
                    <br />
                    <span class="mb-2 d-inline-block">Min. Profit:</span> {{ mammanagerstatistics.min_profit }}
                  </p>
                  <v-spacer></v-spacer>
                  <p class="equity text-right">
                    <span class="mb-2 d-inline-block">Sell:</span> {{ mammanagerstatistics.sell }} <br />
                    <span class="mb-2 d-inline-block">Max. Loss:</span> {{ mammanagerstatistics.maxLoss }}
                    <br />
                    <span class="mb-2 d-inline-block">Min. Loss: </span> {{ mammanagerstatistics.minLoss }}
                  </p>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-3 rounded-0 elevation-0 chart-tab" :color="$vuetify.theme.dark ? '#172233 ' : '#E8F1F8'">
          <v-row dense class="mb-3">
            <v-col md="9" lg="10" sm="8" cols="6">
              <v-card-title class="pt-3 pb-0">Profit / Loss </v-card-title>
            </v-col>
            <v-col md="3" lg="2" sm="4" cols="6">
              <v-select solo :items="slots1" v-model="period" @change="handlePeriodChange"
                append-icon="mdi-chevron-down" label="Click to select" class="custom-select"></v-select>
            </v-col>
          </v-row>
          <profit-chart :trades="managerprofitloss"></profit-chart>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-3 rounded-0 elevation-0 chart-tab" :color="$vuetify.theme.dark ? '#172233 ' : '#E8F1F8'">
          <v-row dense class="mb-3">
            <v-col md="10" sm="8" cols="6">
              <p class="mb-0">Trade by Symbol</p>
            </v-col>
            <v-col md="2" sm="4" cols="6">
              <p class="sub-title mb-0">Total Trades: <span>{{ toptradesbysymbol.totalTrades || 0 }}</span></p>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <symbol-trades :trades="toptradesbysymbol"></symbol-trades>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-3 rounded-0 elevation-0 chart-tab" :color="$vuetify.theme.dark ? '#172233 ' : '#E8F1F8'">
          <v-row dense class="mb-3">
            <v-col cols="12">
              <v-card-title class="pt-3 pb-0">Weekly Trades</v-card-title>
            </v-col>
          </v-row>
          <weekly-trades :trades="mamweeklytrades"></weekly-trades>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-3 rounded-0 elevation-0 chart-tab" :color="$vuetify.theme.dark ? '#172233 ' : '#E8F1F8'">
          <v-row dense class="mb-3">
            <v-col cols="12">
              <v-card-title class="pt-3 pb-0">Monthly Trades</v-card-title>
            </v-col>
          </v-row>
          <hourly-trades :trades="mammonthlytrades"></hourly-trades>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SymbolTrades from "@/components/Mam/SymbolTrades.vue";
import HourlyTrades from "@/components/Mam/HourlyTrades.vue";
import ProfitChart from "@/components/Mam/ProfitChart.vue";
import WeeklyTrades from "@/components/Mam/WeeklyTrades.vue";

import { MAM__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    SymbolTrades,
    ProfitChart,
    WeeklyTrades,
    HourlyTrades,
  },

  data() {
    return {
      slots1: ["This Year", "This Month", "This Week"],
      period: "This Month",
      mamAccount: null
    };
  },

  computed: {
    ...mapState("mam", ["mammonthlytrades", "mamweeklytrades", "toptradesbysymbol", "managerprofitloss", "mammanagerstatistics"]),
  },

  methods: {
    ...mapActions("mam", [
      MAM__ACTIONS.GETMONTHLYTRADES,
      MAM__ACTIONS.GETWEEKLYTRADES,
      MAM__ACTIONS.GETTOPTRADESBYSYMBOL,
      MAM__ACTIONS.GETMANAGERPROFITLOSS,
      MAM__ACTIONS.GETMAMMANAGERSTATISTICS,
    ]),

    async handlePeriodChange() {
      await this[MAM__ACTIONS.GETMANAGERPROFITLOSS]({
        period: this.period === "This Year" ? 'year' : this.period === "This Week" ? 'week' : 'month',
        account: this.mamAccount
      });
    }
  },

  async mounted() {
    this.mamAccount = this.$route.query.account
    await this[MAM__ACTIONS.GETMAMMANAGERSTATISTICS](this.$route.query.account);
    await this[MAM__ACTIONS.GETMONTHLYTRADES](this.$route.query.account);
    await this[MAM__ACTIONS.GETWEEKLYTRADES](this.$route.query.account);
    await this[MAM__ACTIONS.GETTOPTRADESBYSYMBOL](this.$route.query.account);
    await this[MAM__ACTIONS.GETMANAGERPROFITLOSS]({
      period: this.period === "This Year" ? 'year' : this.period === "This Week" ? 'week' : 'month',
      account: this.$route.query.account
    });
  }
};
</script>
